export default __webpack_public_path__ + "static/media/398.edb65d24.svg";